import { setThemePreference } from "mazey";
export const THEME_STORAGE_KEY = "GALLERY_THEME";
export const LIGHT_THEME_LABEL = "Current theme: Light. Switch to dark theme.";
export const DARK_THEME_LABEL = "Current theme: Dark. Switch to light theme.";
export function getAppliedTheme(documentRef) {
    return documentRef.documentElement.getAttribute("data-theme") === "dark"
        ? "dark"
        : "light";
}
export function applyTheme(theme, documentRef = document) {
    const root = documentRef.documentElement;
    root.setAttribute("data-theme", theme);
    root.setAttribute("data-bs-theme", theme);
    const themeColor = documentRef.querySelector("[data-theme-color]");
    if (themeColor) {
        const colorAttribute = theme === "light" ? "data-theme-color-light" : "data-theme-color-dark";
        const color = themeColor.getAttribute(colorAttribute);
        if (color) {
            themeColor.setAttribute("content", color);
        }
    }
    const toggle = documentRef.querySelector(".theme-toggle");
    if (!toggle) {
        return;
    }
    toggle.setAttribute("aria-label", theme === "light" ? LIGHT_THEME_LABEL : DARK_THEME_LABEL);
    const sun = documentRef.querySelector(".theme-toggle__icon--sun");
    const moon = documentRef.querySelector(".theme-toggle__icon--moon");
    if (sun) {
        if (theme === "dark") {
            sun.setAttribute("hidden", "");
        }
        else {
            sun.removeAttribute("hidden");
        }
    }
    if (moon) {
        if (theme === "light") {
            moon.setAttribute("hidden", "");
        }
        else {
            moon.removeAttribute("hidden");
        }
    }
}
export function createThemeController(initialTheme, apply = applyTheme, persist = (theme) => setThemePreference(THEME_STORAGE_KEY, theme)) {
    let currentTheme = initialTheme;
    return {
        getCurrentTheme() {
            return currentTheme;
        },
        toggle() {
            const nextTheme = currentTheme === "light" ? "dark" : "light";
            persist(nextTheme);
            apply(nextTheme);
            currentTheme = nextTheme;
            return currentTheme;
        },
    };
}
